import { render } from "./ScreenChartPink.vue?vue&type=template&id=afb7844e&ts=true"
import script from "./ScreenChartPink.vue?vue&type=script&lang=ts"
export * from "./ScreenChartPink.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__